class WorkInstructionPackageDTO {
  _id;
  title;
  workInstructions;
  jobId;
  sortOrder;
  createdAt;

  constructor(data) {
    this._id = data._id || data.id;
    this.title = data.title;
    this.workInstructions = data.workInstructions || [];
    this.jobId = data.jobId;
    this.sortOrder = data.sortOrder;
    this.createdAt = data.createdAt;
  }
}

module.exports = WorkInstructionPackageDTO;
